import config from 'config';

import { getSession } from '@techstyle/redux-core';

import { loadDmg } from '../../src/actions/dmg';

import { getBuilderContent } from './getBuilderContent';
import { isBuilderEditing } from './isBuilderEditing';
import { isBuilderPreview } from './isBuilderPreview';

const firstTimeVisitorDmgCodes = config.get('public.dmgCodes.firstTimeVisitor');

const returningVisitorDmgCodes = config.get('public.dmgCodes.returningVisitor');

export const getPathName = (path: string | URL) => {
  const placeHolderBaseUrl = 'https://www.example.com';
  const url = new URL(path, placeHolderBaseUrl);
  return url?.pathname;
};

// If there's a DMG code in the query parameter, it will take precedence.
// Otherwise, it will try to get the current DMG code.
// It will either use the current DMG in the session, or if it's not there,
// it will get the corresponding DMG depending on whether the user is a first-time or returning visitor.
const getCurrentDmgCode = ({ session, tld, query }) => {
  if (query?.dmg) {
    return query.dmg;
  }

  if (session.dmGatewayCode) {
    return session.dmGatewayCode;
  }

  if (session.isFirstTimeVisitor) {
    return firstTimeVisitorDmgCodes[tld];
  }

  if (session.isReturningVisitor) {
    return returningVisitorDmgCodes[tld];
  }

  return undefined;
};

export async function getHomePageContent(ctx, isLoggedIn) {
  const { query, store } = ctx;

  const state = store.getState();
  const { tld } = state.domain;
  const defaultContentPromise = getBuilderContent('page', '/', ctx);

  const session = getSession(state as never);

  const dmgCode = getCurrentDmgCode({ session, tld, query });

  const isPreview = isBuilderPreview(ctx.req);
  const isEditing = isBuilderEditing(ctx.query);

  let dmgInfo;
  if (dmgCode) {
    try {
      dmgInfo = await store.dispatch(loadDmg(dmgCode));
    } catch (e) {
      // dmgCode not found, do nothing
    }
  }

  const isLive = !isEditing && !isPreview;
  // Don't use landing pages on Builder editor or preview
  if (dmgInfo?.payload?.redirectUrl && !isLoggedIn && isLive) {
    const builderUrl = getPathName(dmgInfo?.payload?.redirectUrl);

    const dmgCodeContent = await getBuilderContent(
      'landing-page',
      builderUrl,
      ctx
    );

    if (dmgCodeContent) {
      return { ...dmgCodeContent, dmgInfo: dmgInfo?.payload };
    }
  }

  return await defaultContentPromise;
}
